if(typeof Date.prototype.format === 'undefined') {
    Date.prototype.format = function(format) {
        const monthNames1 = (window.locale && window.locale["dateFormat.month"]) || ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
        const monthNames2 = (window.locale && window.locale["dateFormat.month2"]) || ["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня", "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"];
        let date = '';
        format = format.split('');
        for(let i in format) {
            if (format.hasOwnProperty(i)) {
                switch(format[i]) {
                    case 'Y': date += (this.getFullYear() < 10 ? '0' : '') + this.getFullYear(); break;
                    case 'm': date += ((this.getMonth()+1) < 10 ? '0' : '') + (this.getMonth()+1); break;
                    case 'd': date += (this.getDate() < 10 ? '0' : '') + this.getDate(); break;
                    case 'H': date += (this.getHours() < 10 ? '0' : '') + this.getHours(); break;
                    case 'i': date += (this.getMinutes() < 10 ? '0' : '') + this.getMinutes(); break;
                    case 's': date += (this.getSeconds() < 10 ? '0' : '') + this.getSeconds(); break;
                    case 'f': date += monthNames1[this.getMonth()]; break;
                    case 'F': date += monthNames2[this.getMonth()]; break;
                    default: date += format[i];
                }
            }
        }
        return date;
    }
}

if(typeof Date.prototype.getTimestamp === 'undefined') {
    Date.prototype.getTimestamp = function(in_ms) {
        return !in_ms ? Math.round(this.getTime() / 1000) : this.getTime();
    }
}

if(typeof Date.fromTimestamp === 'undefined') {
    Date.fromTimestamp = function(timestamp, in_ms) {
        return new Date(in_ms ? timestamp : timestamp * 1000);
    }
}

if(typeof Date.fromString === 'undefined') {
    Date.fromString = function(str) {
        const reg = new RegExp('^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2}) ([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})$', '');
        const res = reg.exec(str);
        if(res) {
            return new Date(res[1], res[2] - 1, res[3], res[4], res[5], res[6]);
        }
        return new Date();
    };
}

if(typeof Date.nowTimestamp === 'undefined') {
    Date.nowTimestamp = function() {
        return (new Date).getTimestamp();
    };
}

if(typeof Date.getServerTime === 'undefined') {
    Date.getServerTime = function() {
        const date = new Date;
        date.setTime(date.getTime() + (window.serverTimeDifference || 0) * 1000);
        return date;
    };
}

export function date(format, date) {
    if (typeof date === 'undefined') {
        date = format;
        format = null;
    }

    date = date instanceof Date ? date : new Date(parseInt(date) * 1000);

    return format ? date.format(format) : date.toLocaleString();
}

export function deepEqual(a, b) {
    if (a === b) return true;

    const arrA = Array.isArray(a);
    const arrB = Array.isArray(b);
    let i;
    let length;
    let key;

    if (arrA && arrB) {
        length = a.length;
        if (length !== b.length) return false;
        for (i = 0; i < length; i++)
            if (!deepEqual(a[i], b[i])) return false;
        return true;
    }

    if (arrA !== arrB) return false;

    const dateA = a instanceof Date;
    const dateB = b instanceof Date;
    if (dateA !== dateB) return false;
    if (dateA && dateB) return a.getTime() === b.getTime();

    const regexpA = a instanceof RegExp;
    const regexpB = b instanceof RegExp;
    if (regexpA !== regexpB) return false;
    if (regexpA && regexpB) return a.toString() === b.toString();

    if (a instanceof Object && b instanceof Object) {
        const keys = Object.keys(a);
        length = keys.length;

        if (length !== Object.keys(b).length)
            return false;

        for (i = 0; i < length; i++)
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

        for (i = 0; i < length; i++) {
            key = keys[i];
            if (!deepEqual(a[key], b[key])) return false;
        }

        return true;
    }

    return false;
}
